import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ServiceMap } from '../models/service-map';
import { ServiceProviders } from '../models/service-providers';
import { RobiServiceMap } from '../models/robi-service-map';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public selectedItem! :ServiceMap;

  constructor(private httpClient: HttpClient) { }
  public get(){
    return this.httpClient.get<ServiceMap[]>(environment.apiUrl 
      + `/grameenphone/config/get`);
  }
  public getBlMerchants(){
    return this.httpClient.get<ServiceMap[]>(environment.apiUrl 
      + `/banglalinkcloud7/config`);
  }
  public getRobiMerchants(){
    return this.httpClient.get<ServiceMap[]>(environment.apiUrl 
      + `/robi/config`);
  }
  public getByMarchent(marchant: string){
    return this.httpClient.get<ServiceMap[]>(environment.apiUrl 
      + `/grameenphone/config/get_by_marchantet?marchant=${marchant}`);
  }
  public getBlDetailsByMarchent(marchant: string){
    return this.httpClient.get<ServiceMap[]>(environment.apiUrl 
      + `/banglalinkcloud7/config/get_by_marchantet?marchant=${marchant}`);
  }
  public getRobiDetailsByMarchent(marchant: string){
    return this.httpClient.get<RobiServiceMap[]>(environment.apiUrl 
      + `/robi/config/get_by_marchantet?marchant=${marchant}`);
  }
  public getServiceProviders(){
    return this.httpClient.get<ServiceProviders[]>(environment.apiUrl 
      + `/grameenphone/config/get_service_providers`);
  }
  public getBlServiceProviders(){
    return this.httpClient.get<ServiceProviders[]>(environment.apiUrl 
      + `/banglalink/config/get_service_providers`);
  }
  public getRobiServiceProviders(){
    return this.httpClient.get<ServiceProviders[]>(environment.apiUrl 
      + `/robi/config/get_service_providers`);
  }
  public addService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/grameenphone/config/add_product`,val, {headers});
  }
  public updateGpService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/grameenphone/config/update_product`,val, {headers});
  }
  public addBlService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/banglalink/config/add_product`,val, {headers});
  }

  public addRobiService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/robi/config/add_product`,val, {headers});
  }

  public updateBlService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/banglalink/config/update_product`,val, {headers});
  }
  public updateRobiService(val: string){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<any>(environment.apiUrl 
      + `/robi/config/update_product`,val, {headers});
  }
  public getRunningNotifications(){
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get<string[]>(environment.apiUrl 
      + `/grameenphone/config/get_running_notifications`);
  }
}
